export default __webpack_public_path__ + "static/app-loan-2f5dc2066c2e1305f7b4b2542e11e508.svg";